/* @ngInject */
const format = (utils) => {
  const self = {}

  self.user = (_dispatch) => {
    const dispatch = utils.copy(_dispatch)

    dispatch.date = utils.date.timestampToString(dispatch.date)
    dispatch.comment = utils.removeHtmlLineBreak(dispatch.comment)

    return dispatch
  }
  self.server = (_dispatch) => {
    const dispatch = utils.copy(_dispatch)

    dispatch.date = utils.date.stringToServer(dispatch.date)

    return dispatch
  }

  return self
}

export default format



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/dispatch/services/format.service.js